var React = require('react');

function CustomSelectArrow (props) {
    return React.createElement("svg",props,[React.createElement("g",{"clipPath":"url(#clip0_133_1120)","key":0},[React.createElement("path",{"d":"M24 0H0V24H24V0Z","fill":"white","fillOpacity":"0.01","key":0}),React.createElement("path",{"d":"M18.5 9L12.5 15L6.5 9","stroke":"#333333","strokeLinecap":"round","strokeLinejoin":"round","key":1})]),React.createElement("defs",{"key":1},React.createElement("clipPath",{"id":"clip0_133_1120"},React.createElement("rect",{"width":"24","height":"24","fill":"white"})))]);
}

CustomSelectArrow.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none"};

module.exports = CustomSelectArrow;

CustomSelectArrow.default = CustomSelectArrow;
